import { useMutation } from "@tanstack/vue-query"
import { v1 } from "@/axios"

interface UseDeleteSlideshowConfigArgs {
  id: string
  eventVaultId: number
}

export async function deleteSlideshowConfig(id: string, eventVaultId: number) {
  return v1.delete(`/${eventVaultId}/slideshow/${id}`)
}

export function useDeleteSlideshowConfig() {
  return useMutation({
    mutationFn: ({ id, eventVaultId }: UseDeleteSlideshowConfigArgs) => deleteSlideshowConfig(id, eventVaultId),
  })
}
